import { useEffect, useRef } from "react";
import { isVideo, mergeClass } from "../../utils/common";
import CdnImage from "./CdnImage";

export default function NetworkMediaFile({
  file,
  className,
  loading,
  onClick,
  cdnParams,
  fetchPriority,
}: {
  file?: {
    src?: string;
  };
  className?: string;
  loading?: "eager" | "lazy";
  onClick?: () => void;
  cdnParams?: CdnParam;
  fetchPriority?: "high" | "low";
}) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const tryPlay = () => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // Autoplay failed
          console.warn("Autoplay failed", error);
        });
      }
    };

    // Nếu đã có thể play → gọi play()
    video.addEventListener("canplay", tryPlay);

    // Khi component unmount
    return () => {
      video.removeEventListener("canplay", tryPlay);
    };
  }, []);

  if (!file) return null;

  if (isVideo(file.src ?? "")) {
    return (
      <div
        className={mergeClass(
          "oveflow-hidden flex w-full items-center bg-black object-cover",
          className,
        )}
      >
        <video
          ref={videoRef}
          className="w-full object-cover"
          src={file.src}
          muted
          autoPlay
          playsInline
          loop
          preload="auto"
          style={{
            willChange: "transform",
          }}
        />

        {/* <Player
          playsInline
          muted
          autoPlay
          preload="metadata"
          src={file.src || ""}
        >
          <BigPlayButton position="center" />
        </Player> */}
      </div>
    );
  }
  return (
    <CdnImage
      src={file.src ?? "https://placehold.co/80x80"}
      alt={file.src}
      className={mergeClass(
        "object-cover",
        onClick ? "cursor-pointer" : "",
        className,
      )}
      loading={loading}
      onClick={onClick}
      cdnParams={cdnParams}
      fetchPriority={fetchPriority}
    />
  );
}
